import React, { useEffect } from 'react'

import { Dialog } from '../../../../components/Elements/Modal/Modal'
import { ConnectionStatus, Platforms } from '../../models'
import usePlatformsModalsStore from '../../stores/platformsModals.store'

import { RenderConnectionModal } from './ModalContent/RenderModalContent'

interface ConnectionModalProps {
  platform: Platforms
  isOpen: boolean
  onOpenChange: (a: boolean) => void
  onClose?: (a: boolean) => void
  connectionStatus?: ConnectionStatus
  connectionId?: number
  isEnabled?: boolean
  isEdit?: boolean
}

const ConnectionModal = ({
  platform,
  isOpen,
  onOpenChange,
  connectionStatus,
  isEnabled,
  connectionId,
  isEdit,
}: ConnectionModalProps) => {
  const { setSelectedConnectionId } = usePlatformsModalsStore()
  // resets modal before close/open it
  const onModalChange = (a: boolean) => {
    onOpenChange(a)
  }

  const closeModal = () => {
    onModalChange(false)
  }

  useEffect(() => {
    if (connectionId) {
      setSelectedConnectionId(connectionId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectionId])

  return (
    <Dialog
      borderRadius="4px"
      closeButtonPosition={{ top: '10px', right: '10px' }}
      isOpen={isOpen}
      onOpenChange={onModalChange}
    >
      <RenderConnectionModal
        platform={platform}
        onClose={closeModal}
        connectionStatus={connectionStatus as ConnectionStatus}
        isEnabled={isEnabled}
        isEdit={isEdit}
      />
    </Dialog>
  )
}

export default ConnectionModal
